module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.title
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19c15068", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c15068"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/corecontrols/tooltipcontrol/tooltipcontrol.scp.html
// module id = 454
// module chunks = 0